import { Injectable } from '@angular/core';
import { TOUCH_ERROR_RANGE } from 'src/app/constants/dialogue';

@Injectable({
  providedIn: 'root'
})
export class DiaCommonService {

  // 移动端的聊天界面DOM元素
  public mobMesMainCon!: HTMLDivElement
  // 标记当前是否是微信内嵌浏览器
  public isWechatBrowser: boolean = false

  // 点击时的按钮坐标值
  public touchStartX: number = 0
  public touchStartY: number = 0

  // 处理点击事件误触
  public handleTouchStartEvent(e: TouchEvent) {
    this.touchStartX = e.touches[0].clientX
    this.touchStartY = e.touches[0].clientY
  }

  // 点击完成判断
  public handleTouchUnintendedAct(e: TouchEvent) {
    if (Math.abs(e.changedTouches[0].clientX - this.touchStartX) > TOUCH_ERROR_RANGE
      || Math.abs(e.changedTouches[0].clientY - this.touchStartY) > TOUCH_ERROR_RANGE) {
      return false
    }
    return true
  }
  
}
